import { render, staticRenderFns } from "./OperacionesList.vue?vue&type=template&id=280f065d&"
import script from "./OperacionesList.vue?vue&type=script&lang=js&"
export * from "./OperacionesList.vue?vue&type=script&lang=js&"
import style0 from "./OperacionesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports